<template>
  <BaseButton
    class="relative"
    :class="props.loading ? 'btn-loading' : ''"
    :disabled="props.disabled || props.loading"
    :type="props.type"
  >
    <div
      class="absolute inset-0 flex items-center justify-center transition-opacity duration-100"
      :class="props.loading ? '' : 'opacity-0'"
    >
      <SvgLoadingSpinner />
    </div>
    <span
      class="transition-opacity duration-100"
      :class="props.loading ? 'opacity-0' : ''"
      ><slot
    /></span>
  </BaseButton>
</template>

<script setup lang="ts">
import type { BaseAsyncButtonProps } from './types'

const props = withDefaults(defineProps<BaseAsyncButtonProps>(), {
  loading: false,
})
</script>
